<fieldset>
 <legend>
  AttributionFromMAPA
 </legend>
 <fieldset>
 <legend>
  criteresAttribution
 </legend>
 <app-type-cr-jugement  [uid]="getUid()" [parentForm]="parentForm" [criteresAttribution]="attributionFromMAPA.criteresAttribution"></app-type-cr-jugement>
</fieldset>

<!---->

<fieldset>
 <legend>
  descriptionReduite
 </legend>
 <app-description-reduite  [uid]="getUid()" [parentForm]="parentForm" [descriptionReduite]="attributionFromMAPA.descriptionReduite"></app-description-reduite>
</fieldset>

<!---->

<fieldset>
 <legend>
  autresInformations
 </legend>
 <app-type-autres-infosATTR  [uid]="getUid()" [parentForm]="parentForm" [autresInformations]="attributionFromMAPA.autresInformations"></app-type-autres-infosATTR>
</fieldset>

<!---->

<fieldset>
 <legend>
  avisInitial
 </legend>
 <app-avis-initial-type  [uid]="getUid()" [parentForm]="parentForm" [avisInitial]="attributionFromMAPA.avisInitial"></app-avis-initial-type>
</fieldset>

<!---->

<fieldset>
 <legend>
  procedure
 </legend>
 <app-procedure  [uid]="getUid()" [parentForm]="parentForm" [procedure]="attributionFromMAPA.procedure"></app-procedure>
</fieldset>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="attributionFromMAPA.pasAvisInitial"

[label]="'pasAvisInitial'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_pasAvisInitial'">
</app-form-input>

<!---->

<fieldset>
 <legend>
  attribution
 </legend>
 <app-attribution  [uid]="getUid()" [parentForm]="parentForm" [attribution]="attributionFromMAPA.attribution"></app-attribution>
</fieldset>
</fieldset>
